/**
 * Main Event Bus. Used w/CommMixin
 */
import Vue from "vue";
var EventBus = new Vue();
export default EventBus;
